import { render, staticRenderFns } from "./PercentPottWidget.vue?vue&type=template&id=57965f62&"
import script from "./PercentPottWidget.vue?vue&type=script&lang=js&"
export * from "./PercentPottWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports